import React from 'react';

import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';

const menuItems = [
  {
    title: 'Product',
    url: null,
    subItems: [
      {
        label: 'Analytics',
        title: 'Customer Behavior',
        url: '/platform/',
        colorTheme: 'emerald',
        subItems: [
          { title: 'Product Analytics', url: '/platform/product-analytics/' },
          { title: 'Mobile App Analytics', url: '/platform/mobile-apps/' },
          { title: 'Session Replay', url: '/platform/session-replay/' },
        ],
        cta: {
          title: 'Watch a product tour ↗',
          url: '/product-tour/?utm_campaign=WC-2024-11-Gated-Product-Tour',
        },
      },
      {
        label: 'Workforce',
        title: 'Employee Experience',
        url: '/platform/workforce/',
        colorTheme: 'pink',
        subItems: [
          { title: 'Workflow Efficiency', url: '/platform/workforce/productivity/' },
          { title: 'Support Acceleration', url: '/platform/workforce/internal-support/' },
          { title: 'Spend Optimization', url: '/platform/workforce/reduce-spend/' },
        ],
        cta: {
          title: 'Watch a product tour ↗',
          url: '/product-tour/?utm_campaign=WC-2024-11-Gated-Product-Tour&utm_product=wf',
        },
      },
      {
        label: 'Anywhere',
        title: 'Data Ecosystem',
        url: '/platform/anywhere/',
        colorTheme: 'lilac',
        subItems: [
          { title: 'Tech Stack Enrichment', url: '/platform/anywhere/warehouse/' },
          { title: 'Real-Time Personalization', url: '/platform/anywhere/activation/' },
        ],
      },
    ],
    callouts: [
      {
        title: 'Platform Overview',
        description: 'Each product delivers. Together, they transform.',
        url: '/platform/',
        colorTheme: null,
        imageSrc: null,
      },
      {
        title: 'Meet StoryAI',
        description: 'Our AI agents powering it all.',
        url: '/platform/storyai/',
        colorTheme: 'gradient',
        imageSrc: null,
      },
    ],
  },
  {
    title: 'Solutions',
    url: null,
    subItems: [
      {
        label: 'By Industry',
        title: null,
        url: null,
        colorTheme: null,
        subItems: [
          { title: 'Retail & Ecommerce', url: '/industries/ecommerce-retail/' },
          { title: 'Food & Beverage', url: '/industries/food-beverage/' },
          { title: 'Travel & Hospitality', url: '/industries/travel-hospitality/' },
          { title: 'Finance & Insurance', url: '/industries/finance-insurance/' },
          { title: 'Gaming', url: '/industries/gaming/' },
          { title: 'SaaS', url: '/industries/saas/' },
        ],
        cta: null,
      },
      {
        label: 'By Team',
        title: null,
        url: null,
        colorTheme: null,
        subItems: [
          { title: 'Product & Engineering', url: '/solutions/product-management/' },
          { title: 'Data', url: '/solutions/data-teams/' },
          { title: 'Customer Support', url: '/solutions/customer-success/' },
          { title: 'IT & Internal Support', url: '/solutions/internal-support-it/' },
          { title: 'Marketing', url: '/solutions/marketing/' },
        ],
        cta: null,
      },
    ],
    callouts: [
      {
        title: 'Solutions Catalog',
        description: 'Explore tailored resources for every industry and team',
        url: '/solutions/',
        colorTheme: null,
        imageSrc: null,
      },
    ],
  },
  { title: 'Plans & Pricing', url: '/plans/' },
  {
    title: 'Resources',
    url: null,
    subItems: [
      {
        label: 'Resources',
        title: null,
        url: null,
        colorTheme: null,
        subItems: [
          { title: 'All Resources', url: '/resources/' },
          { title: 'Blog', url: '/blog/' },
          { title: 'Customer Stories', url: '/customer-story/all/' },
          { title: 'Help Center', url: 'https://help.fullstory.com/hc/en-us' },
          { title: 'Learning Courses', url: 'https://learn.fullstory.com/app/' },
          { title: 'Dev Resources', url: 'https://developer.fullstory.com/' },
        ],
        cta: null,
      },
      {
        label: 'Company',
        title: null,
        url: null,
        colorTheme: null,
        subItems: [
          { title: 'About Us', url: '/about-us/' },
          { title: 'News', url: '/news/' },
          { title: 'Events', url: '/events/' },
          { title: 'Privacy & Security', url: '/privacy-resources/' },
          { title: 'Careers', url: '/careers/' },
          { title: 'Partners', url: '/partners/' },
        ],
        cta: null,
      },
    ],
    callouts: [
      {
        title: 'Experience the Benchmark Report',
        description: 'Our immersive benchmark experience built from 14B sessions.',
        url: '/digital-product-benchmark-report/',
        colorTheme: 'evergreen',
        imageSrc: '/images/insight-springs-mountains.svg',
      },
    ],
  },
];

export default function Navigation() {
  return (
    <nav style={{ height: '100%' }} data-analytics-component={'navigation-menus'}>
      <svg style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" width="0" height="0">
        <defs>
          <radialGradient id="arrowGradient" cx="0" cy="0" r="1">
            <stop offset="30%" stopColor="#07c79990"></stop>
            <stop offset="80%" stopColor="#a23cf090"></stop>
            <stop offset="100%" stopColor="#ffb863"></stop>
          </radialGradient>
        </defs>
      </svg>
      <DesktopMenu menuItems={menuItems} />
      <MobileMenu menuItems={menuItems} />
    </nav>
  );
}
